import { useQuery } from 'react-query';
import DairyService from '~/api/services/dairy';
import { onError } from '~/utils/helpers';

const getManagerUsers = (data) => useQuery(
  'manager-users',
  () => DairyService.getManagerUsers(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getManagerUsersOptions = () => useQuery(
  'manager-users-options',
  DairyService.getManagerOptions,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCountManagerUsers = (data?) => useQuery(
  'manager-users-count',
  () => DairyService.getCountManagerUsers(data),
  {
    onError,
    refetchOnMount: false,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getManagersIndexOptions = () => useQuery(
  'manager-index-options',
  () => DairyService.getManagersIndexOptions(),
  {
    onError,
    refetchOnMount: false,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

export const ManagerUsersQuery = {
  getManagerUsers,
  getManagerUsersOptions,
  getCountManagerUsers,
  getManagersIndexOptions
}